import React from "react";
import PropTypes from "prop-types";
import _ from 'lodash'


const EditBar = (props) => {

    const {profile} = props;

    return <div className="editBarContainer">
    <div className="editBar">
        <div className="profile-image" style={{backgroundImage: `url(${profile.avatarUrl}`}}></div>
        <div className="infoWrapper">
            <p>{profile.name} {profile.lastName}</p>
            <p className="small">Location: {profile.location}</p>
        </div>
         <button onClick={props.onEdit} className="edit">
         <i className="ion-edit"/>
         </button>
    </div>
    <hr></hr>
    </div>
}

EditBar.propTypes = {
    avatarUrl: PropTypes.string,
    profile: PropTypes.object,
    onEdit: PropTypes.func
}

export default EditBar;